import { setStorage } from '@/utils/storage';
import { request } from './index';
export const systemUrls = {
	login: '/login', // 验证码登录
	passLogin: '/passlogin',
	renewToken: '/renew',
	accountResetPassword: '/account/password/reset',
	getAccount: '/account/get',
	sendCode: '/sms/auth/mobile/send',
	getClientToken: (clientId: string, refreshToken: string) =>
		`/client/${clientId}/refresh/${refreshToken}/create`,
	verifyCode: '/sms/code/verify',
	getMemberNewToken: '/refreshToken/get',
};
export type IStaffLoginProps = {
	areaCode: string;
	mobile: string;
	code: string;
	password?: string;
};

export type IAccountLoginProps = {
	account: {
		areaCode: string;
		mobile: string;
	};
	secure: {
		password?: string;
		smsCode?: string;
	};
};
export interface ISendCode {
	countryCode: string;
	mobile: string;
	type: string;
}
export function login(params: IAccountLoginProps) {
	return request(systemUrls.login, params);
}
export function passLogin(params: IStaffLoginProps) {
	return request(systemUrls.passLogin, { body: params });
}

interface IRenewTokenProps {
	accessToken: string;
	refreshToken: string;
}
export function renewToken(token: string) {
	return new Promise<void>((resolve) => {
		request(`/${token}` + systemUrls.renewToken, {}, 'get').then((res) => {
			setStorage('accessToken', (res as IRenewTokenProps).accessToken, 'locale');
			setStorage('refreshToken', (res as IRenewTokenProps).refreshToken, 'locale');
			resolve();
		});
	});
}
export function restPassword(data: IRestPassword) {
	return request(systemUrls.accountResetPassword, { body: data });
}
export function getAccount() {
	return request(systemUrls.getAccount, {}, 'get');
}
export function sendCode(params: ISendCode) {
	return request(systemUrls.sendCode, { body: params });
}

/**
 * 获取置换token
 * @param params clientId: string, refreshToken: string
 */
export const getClientRefreshToken = (clientId: string, refreshToken: string): Promise<null> => {
	return new Promise((resolve) => {
		request(systemUrls.getClientToken(clientId, refreshToken), {}, 'get').then((res) => {
			resolve((res as unknown) as null);
		});
	});
};

export const verifyCode = (body: {
	authCode: string;
	countryCode: string;
	mobile: string;
	type: string;
}): Promise<boolean> => {
	return new Promise((resolve) => {
		request(systemUrls.verifyCode, { body }).then((res) => {
			resolve(true);
		});
	});
};
export const getMemberNewToken = (id: string) => {
	return new Promise((resolve) => {
		request(systemUrls.getMemberNewToken, { body: id }).then((res) => {
			resolve(res);
		});
	});
};
